export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-slate-800 to-slate-950 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/e91042ba6b64d325371245c365026672.png" 
                alt="LA.RA. SERVICE SRL" 
                className="h-28 w-auto bg-white rounded-lg p-2"
              />
            </div>
            <p className="text-white/70 leading-relaxed mb-4">
              Eccellenza nelle lavorazioni meccaniche e commercio ferro per l'edilizia. Partner affidabile per il settore edile e meccanico.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Servizi</h4>
            <ul className="space-y-3">
              <li>
                <a href="#servizi" className="text-white/70 hover:text-white transition-colors cursor-pointer">
                  Lavorazioni Meccaniche
                </a>
              </li>
              <li>
                <a href="#servizi" className="text-white/70 hover:text-white transition-colors cursor-pointer">
                  Ferro per Edilizia
                </a>
              </li>
              <li>
                <a href="#servizi" className="text-white/70 hover:text-white transition-colors cursor-pointer">
                  Strutture Metalliche
                </a>
              </li>
              <li>
                <a href="#servizi" className="text-white/70 hover:text-white transition-colors cursor-pointer">
                  Supporto Tecnico
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Link Rapidi</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-white/70 hover:text-white transition-colors cursor-pointer text-left"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('chi-siamo')}
                  className="text-white/70 hover:text-white transition-colors cursor-pointer text-left"
                >
                  Chi Siamo
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('galleria')}
                  className="text-white/70 hover:text-white transition-colors cursor-pointer text-left"
                >
                  Galleria
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contatti')}
                  className="text-white/70 hover:text-white transition-colors cursor-pointer text-left"
                >
                  Contatti
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Contatti</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-xl mr-3 mt-1"></i>
                <span className="text-white/70">Prato, Toscana (Italia)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-xl mr-3 mt-1"></i>
                <span className="text-white/70">infolaraservice@gmail.com</span>
              </li>
              <li className="flex items-start">
                <i className="ri-time-line text-xl mr-3 mt-1"></i>
                <div className="text-white/70">
                  <p>Lun - Ven: 8:00 - 18:00</p>
                  <p>Sab: 8:00 - 13:00</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/60 text-sm">
              © 2025 LA.RA. SERVICE SRL. Tutti i diritti riservati.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}